import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

import { Button, Modal } from "@ts-digital/vrc";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInitials } from "../../../libs/utils";
import LoaderSimple from "../../general/loader";
import VaporTimeline from "../../vapor/timeline";
import "./style.css";
import { FormattedMessage, useIntl } from "react-intl";
import FulfilmentsActivityAttachments from "./attachments";
import moment from "moment";
import { setFulfilmentClosed } from "../../../store/actions/fulfilments/activities";
import { displayErrorToast, displaySuccessToast } from "../../../store/actions/overflowNotification";
import { useF24Token } from "../../../views/f24";

const reworkActivities = (activities, onAttachmentClick) => {
  let items = [];
  activities.map((it) => {
    let tmpIt = { ...it };
    tmpIt.description = (
      <React.Fragment>
        {tmpIt.description}&nbsp;
        {it.attachments?.length > 0 && (
          <div
            onClick={() => {
              onAttachmentClick(it);
            }}
            className="ts-vapor-timeline-item-attachments-icon"
          >
            <FontAwesomeIcon icon={("fal", "paperclip")} />
          </div>
        )}
      </React.Fragment>
    );
    return items.push(tmpIt);
  });
  return items;
};

const FulfilmentActivitiesPage = (props) => {
  const { response, companySel, customerId, fulfilmentId, reloadData } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const main = useSelector((state) => state.main);
  const company = useSelector((state) => state.company);
  const fulfilments = useSelector((state) => state.fulfilments);

  const [drawerActivityAttachments, setDrawerActivityAttachments] = useState(null);
  const [status, setStatus] = useState("todo");
  const [closeDialog, setCloseDialog] = useState(false);

  const { token } = useF24Token("d98f2634-1eb1-41e0-8292-702f5ea56df3", auth, true, new Date());

  useEffect(() => {
    if (response && response.fulfilment) {
      if (response.completed) {
        setStatus("completed");
        return;
      }
      let checkDiff = moment(response.fulfilment.deadline).diff(moment(), "days");
      if (checkDiff < 0) {
        setStatus("expired");
      }
    }
  }, [response]);

  const convertActivitiesToTimeline = (activities, completedActivities) => {
    let items = [];
    let ragioneSociale = "";
    let nextToComplete = null;
    activities.map((activity) => {
      ragioneSociale = "";
      let checkCompleted = completedActivities.find((x) => x.activityId === activity.id);
      if (checkCompleted) {
        let findCompany = company.companies.find((x) => x.uuid === checkCompleted.customerId);
        if (findCompany) {
          ragioneSociale = findCompany.ragioneSociale;
        }
      }
      let dateCompleted = checkCompleted ? moment(checkCompleted.completedAt).format("D MMMM YYYY") : "";
      items.push({
        id: activity.id,
        fulfilmentId: response.fulfilment.id,
        description: activity.name,
        subtitle: checkCompleted ? ragioneSociale : "",
        tip: dateCompleted,
        completed: checkCompleted,
        nextToComplete: !nextToComplete && !checkCompleted,
      });
      if (!checkCompleted && !nextToComplete) {
        nextToComplete = true;
      }
      return null;
    });
    if (items.length > 0) {
      items.push({
        id: items.length + 2,
        description: "Scadenza adempimento",
        subtitle: "",
        last: true,
        tip: moment(response.fulfilment.deadline).format("D MMMM YYYY"),
        completed: activities.length === completedActivities.length,
      });
    }
    return items;
  };

  const onCloseFulfilmentConfirmClick = () => {
    dispatch(setFulfilmentClosed(auth, fulfilments.fulfilmentActivities.linkId, main.accountantUuidSelected, main.companyUuidSelected))
      .then((res) => {
        navigate("/fulfilments");
        dispatch(displaySuccessToast("Adempimento chiuso correttamente"));
      })
      .catch((err) => {
        setCloseDialog(false);
        dispatch(displayErrorToast("Errore durante la chiusura dell'adempimento"));
      });
  };
  const reworkedActivitiesForTimeline = reworkActivities(
    convertActivitiesToTimeline(
      response.fulfilment && response.fulfilment.activities ? response.fulfilment.activities : [],
      response.completedActivities ? response.completedActivities : []
    ),
    setDrawerActivityAttachments
  );

  const renderStatus = (status = "todo") => {
    return (
      <div className="dbx-fulfilments-activities-status">
        <div className={"dbx-fulfilments-activities-status-icon icon-" + status}>
          <FontAwesomeIcon icon={["fas", status === "expired" ? "exclamation-circle" : status === "completed" ? "check-circle" : "clock"]} />
        </div>
        <div className="dbx-fulfilments-activities-status-text">
          <FormattedMessage
            id={"fulfilments.statuses." + status}
            values={
              status === "todo"
                ? {
                    period: (
                      <React.Fragment>
                        <br />
                        <strong>
                          {response && response.fulfilment && moment(response.fulfilment.deadline).diff(moment(), "days")}{" "}
                          {useIntl().formatMessage({ id: "generic.days" })}
                        </strong>
                      </React.Fragment>
                    ),
                  }
                : status === "completed"
                ? {
                    date: (
                      <React.Fragment>
                        <br />
                        <strong>{moment(response.completedAt).format("DD MMM YYYY")}</strong>
                      </React.Fragment>
                    ),
                  }
                : {
                    date: (
                      <React.Fragment>
                        <br />
                        <strong>{moment(response.fulfilment.deadline).format("DD MMM YYYY")}</strong>
                      </React.Fragment>
                    ),
                  }
            }
          />
        </div>
      </div>
    );
  };

  return (
    <div className="dbx-fulfilments-activities-root">
      {drawerActivityAttachments && (
        <FulfilmentsActivityAttachments activity={drawerActivityAttachments} setDrawerActivityAttachments={setDrawerActivityAttachments} />
      )}
      {fulfilments.isGettingFulfilmentActivities && (
        <div className="dbx-fulfilments-activities-loader">
          <LoaderSimple message="Caricamento dati adempimenti..." />
        </div>
      )}
      {!fulfilments.isGettingFulfilmentActivities && (
        <React.Fragment>
          <div className="dbx-fulfilments-activities-header">
            <div className="dbx-fulfilments-activities-header-col header-col-info1">
              <div className="dbx-fulfilments-activities-header-row">
                <div className="roundUser" style={{ marginRight: 10 }}>
                  <span>{getInitials(companySel.ragioneSociale)}</span>
                </div>
                <div>{companySel.ragioneSociale}</div>
              </div>
              <div className="dbx-fulfilments-activities-header-row">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    lineHeight: "20px",
                  }}
                >
                  <div>
                    <strong>Adempimento:</strong> {response && response.fulfilment && response.fulfilment.name}
                  </div>
                  <div>
                    <strong>Descrizione:</strong> {response && response.fulfilment && response.fulfilment.description}
                  </div>
                </div>
              </div>
            </div>
            <div className="dbx-fulfilments-activities-header-col header-col-info2">
              <div className="dbx-fulfilments-activities-header-row">
                &nbsp;
                {/* <div className="dbx-fulfilments-activities-header-link">
                  <FontAwesomeIcon icon={["fal", "pencil"]} /> Modifica Driver
                </div>*/}
              </div>
              <div className="dbx-fulfilments-activities-header-row">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    lineHeight: "20px",
                  }}
                >
                  <div>
                    <strong>Scadenza:</strong> {response && response.fulfilment && moment(response.fulfilment.deadline).format("DD MMMM YYYY")}
                  </div>
                  <div>&nbsp;</div>
                </div>
              </div>
            </div>
            <div className="dbx-fulfilments-activities-header-col header-col-status">
              <div className="dbx-fulfilments-activities-header-row full-height">{renderStatus(status)}</div>
            </div>
            <div className="dbx-fulfilments-activities-header-col header-col-buttons">
              <Button
                onClick={() => {
                  navigate("/fulfilments?customerId=" + customerId + "&from=" + fulfilmentId);
                }}
                kind="tertiary"
              >
                Tutti gli adempimenti del cliente
              </Button>
              <Button kind="secondary">
                <div className="dbx-fulfilments-activities-header-buttons-download">
                  <div>
                    <FontAwesomeIcon icon={["fal", "arrow-to-bottom"]} />
                  </div>
                  <div>Scarica report</div>
                  <div>&nbsp;</div>
                </div>
              </Button>
            </div>
          </div>
          <div className="dbx-fulfilments-activities-body">
            <VaporTimeline reloadData={reloadData} items={reworkedActivitiesForTimeline} customerId={customerId} />
          </div>
          <div className="dbx-fulfilments-activities-footer">
            {["todo", "expired"].indexOf(status) > -1 && (
              <div className="dbx-fulfilments-activities-actions">
                <div className="dbx-fulfilments-activities-action-close">
                  <Button onClick={() => setCloseDialog(true)}>Concludi adempimento</Button>
                </div>
              </div>
            )}
          </div>

          {closeDialog && (
            <Modal
              onClose={() => setCloseDialog(false)}
              visible={closeDialog}
              title={"Chiusura adempimento"}
              maskClosable={false}
              footer={
                !fulfilments.isClosingFulfilment && (
                  <div className="dbx-fulfilment-activities-modal-footer">
                    <Button onClick={() => setCloseDialog(false)} kind="secondary">
                      Annulla
                    </Button>
                    <Button onClick={() => onCloseFulfilmentConfirmClick()}>Chiudi adempimento</Button>
                  </div>
                )
              }
            >
              {fulfilments.isClosingFulfilment ? (
                <div className="dbx-fulfilment-activities-modal-spinner">
                  <LoaderSimple />
                </div>
              ) : (
                <div className="dbx-fulfilment-activities-modal-root">
                  Sei sicuro di voler chiudere l'adempimento?
                  <br />
                  L'operazione è irreversibile.
                </div>
              )}
            </Modal>
          )}
        </React.Fragment>
      )}
      {token && <iframe src={`https://f24-dev.teamsystem.com/?f24token=${token}`} title="f24-dev" height={800} width="100%" />}
    </div>
  );
};

export default FulfilmentActivitiesPage;
